import image1 from './1.webp';
import image10 from './10.webp';
import image2 from './2.webp';
import image3 from './3.webp';
import image4 from './4.webp';
import image5 from './5.webp';
import image6 from './6.webp';
import image7 from './7.webp';
import image8 from './8.webp';
import image9 from './9.webp';
import topDecoration from './background.webp';
import topSeparator from './separator.webp';

const section1 = [image1, image2, image3];
const section2 = [image4, image5, image6, image7];
const section3 = [image8, image9, image10];

export const topSections = [section1, section2, section3];
export { topDecoration, topSeparator };
